module.exports = __webpack_public_path__ + "static/media/Srinath.c1fffcc1.svg";